export default "__VITE_ASSET__Da2XABlS__"